// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"2504ca6d","285":"a5de0a39","631":"bee19819","760":"1443cf5c","774":"23ca3342","787":"28cb0dcd","819":"48405473","910":"98f14639"}[chunkId] + ".chunk.js";
};